<!-- Scratch Card List Page -->
<div [ngClass]="{
    'bg-gradient-to-b from-[#0D070C] via-[#030204] to-[#030204] relative': !token || isLandingPage,
    'lg:px-12': isDashBoard,
    'px-3 sm:px-6 md:px-8 lg:px-16 py-4 sc-standalone-inset': !isDashBoard
  }">

  <!-- Scratch game wallet (headless balance listener) -->
  @if (isScratchCardPage && customerId) {
    <app-game-wallet-panel
      #walletPanel
      [hideControls]="true"
      [balanceOnly]="true"
      gameCode="SCRATCH"
      gameName="Scratch"
      [customerId]="customerId"
      (balanceChanged)="onGameBalance($event)">
    </app-game-wallet-panel>
  }

  <!-- ───── HOME / LANDING HEADER (when embedded in home / landing) ───── -->
  @if (isHomePage && !isScratchCardPage) {
    <div class="flex flex-col md:flex-row items-center justify-between gap-6 mb-8 pt-6 px-2 md:pt-12">
      <div class="flex items-center gap-4 w-full max-w-[900px]">
        <!-- Accent Pill Bar -->
        <div class="w-[4px] h-[55px] md:h-[75px] rounded-full bg-gradient-to-b from-[#E7CA96] via-[#C71650] to-[#4D0A24] shadow-[0_0_16px_rgba(231, 202, 150,0.6)]">
        </div>

        <div class="w-full bg-gradient-to-r from-[#120810]/80 via-[#0D070C]/50 to-transparent border-l border-rosegold-400/20 px-4 md:px-6 py-3.5 rounded-r-2xl backdrop-blur-md">
          <p class="text-[#E7CA96] font-bold tracking-widest text-xs md:text-sm mb-1 uppercase flex items-center gap-2">
            <span class="inline-block w-2 h-2 rounded-full bg-[#C71650] animate-pulse"></span>
            Try Your Luck
          </p>
          <h2 class="text-white font-bold text-[18px] sm:text-[22px] lg:text-[38px] leading-tight">
            <span class="text-[#FAF4EB]">Scratch the Card, </span>
            <span class="bg-clip-text text-transparent bg-gradient-to-r from-[#F6E9D5] via-[#E7CA96] to-[#FFAC96]">
              Reveal Your Reward</span>
          </h2>
        </div>
      </div>

      <button class="sc-show-more-btn hidden md:inline-flex" (click)="redirectToSignUp()">
        <span>Show More</span>
        <svg class="w-4 h-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  }

  <!-- ───── STANDALONE SCRATCH PAGE HEADER (LOBBY BAR & FILTERS) ───── -->
  <div class="sc-header-panel mb-6" *ngIf="!isLandingPage && !isDashboardPage">
    <!-- Top Section: Lobby (Left) | Title & Subtitle (Center) | Balance & Play Book (Right) -->
    <div class="sc-top-grid">
      <!-- Left: Lobby Back Button -->
      <div class="sc-top-left">
        <button class="sc-lobby-pill" (click)="goBack()" title="Back to Lobby">
          <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          <span>Lobby</span>
        </button>
      </div>

      <!-- Center: Title, Live Badge & Subtitle -->
      <div class="sc-top-center">
        <div class="sc-title-row">
          <h1 class="sc-title-text">Scratch Cards</h1>
          <div class="sc-live-badge">
            <span class="sc-live-dot"></span>
            <span class="sc-live-text">LIVE</span>
          </div>
        </div>
        <p class="sc-subtitle-text">
          Scratch the foil to reveal instant cash rewards up to $2,000! Pick your lucky card and unlock your jackpot today.
        </p>
      </div>

      <!-- Right: Balance Pill & Play Book Button -->
      <div class="sc-top-right">
        <!-- Balance Pill -->
        <div class="sc-balance-pill" (click)="openWalletDeposit()" [title]="customerId ? 'Click to manage balance' : 'Scratch Balance'">
          <span class="sc-balance-label">BALANCE:</span>
          <span class="sc-balance-val">${{ scratchBalance.toFixed(2) }}</span>
        </div>

        <!-- Play Book Pill Button -->
        <button class="sc-playbook-pill" (click)="showGuide()" title="How to Play">
          <span>Play Book</span>
        </button>
      </div>
    </div>

    <!-- Bottom Row: Search (Left) & Price Filter Chips (Right) -->
    <div class="sc-bottom-row mt-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
      <!-- Search Input Capsule -->
      <div class="sc-search-capsule">
        <svg class="sc-search-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          class="sc-search-field"
          placeholder="Search card by name or price..."
          [(ngModel)]="searchTerm"
        />
        <button
          *ngIf="searchTerm"
          (click)="searchTerm = ''"
          class="sc-search-clear-btn"
          title="Clear search"
        >
          <svg class="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>

      <!-- Quick Filter Pills -->
      <div class="sc-filter-pills-wrap">
        <button
          *ngFor="let filter of priceFilters"
          (click)="setPriceFilter(filter)"
          class="sc-filter-chip"
          [class.active]="selectedPriceFilter === filter"
        >
          <span *ngIf="filter === 'all'">All Cards</span>
          <span *ngIf="filter !== 'all'">${{ filter }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- ───── CARDS GRID ───── -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 pt-1 overflow-visible" [ngClass]="{
      'container mx-auto': isLandingPage
    }">
    <div *ngFor="let card of filteredScratchCards; trackBy: trackByTitle" class="gift-card-wrapper">

      <!-- Scratch Card Component (Luxury Casino Ticket) -->
      <div class="gift-card" (click)="goToBuyNow(card)">
        <!-- Background Pattern -->
        <img loading="lazy" [src]="card.bgImage" alt="" class="gift-card-bg" />

        <!-- Card Top Bar: Badges -->
        <div class="gift-card-top-bar">
          <div class="gift-card-badge">
            <span class="badge-icon">
              <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
              </svg>
            </span>
            <span class="badge-text">INSTANT WIN</span>
          </div>

          <div class="gift-card-price-chip">
            <svg class="ticket-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
            </svg>
            <span class="price-chip-label">TICKET</span>
            <span class="price-chip-val">${{ card.ticketprice }}</span>
          </div>
        </div>

        <!-- Hero Showcase Stage (3D Treasure & Title) -->
        <div class="gift-card-stage">
          <div class="gift-card-orb"></div>
          <div class="gift-card-pedestal"></div>
          <img loading="lazy" [src]="card.treasure" alt="{{ card.title }}" class="gift-card-image" />
          <h3 class="gift-card-title">{{ card.title }}</h3>
        </div>

        <!-- Payout & Scratch Foil Tier -->
        <div class="gift-card-payout-box">
          <div class="payout-left">
            <span class="payout-label">WIN UP TO</span>
            <span class="payout-amount">{{ card.winning }}</span>
          </div>

          <div class="payout-right">
            <div class="gift-card-scratch">
              <div class="foil-glimmer"></div>
              <svg class="foil-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l2.4 7.4h7.6l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4-6.2-4.5h7.6z"/>
              </svg>
              <span>SCRATCH TO WIN</span>
            </div>
          </div>
        </div>

        <!-- CTA Action Button -->
        <button class="gift-card-btn" (click)="$event.stopPropagation(); goToBuyNow(card)">
          <span>Play Now</span>
          <svg class="w-4 h-4 ml-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>

    </div>

    <!-- Empty State when No Cards Match Search or Filter -->
    <div *ngIf="filteredScratchCards.length === 0" class="sc-empty-state col-span-full">
      <div class="empty-icon-box">
        <svg class="w-10 h-10 text-[#E7CA96]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <h3 class="text-white text-lg font-bold mt-3">No Scratch Cards Found</h3>
      <p class="text-[#C2ABA3] text-sm mt-1 max-w-sm">
        No cards match your current search or price filter. Try selecting a different price or clear filters.
      </p>
      <button (click)="clearFilters()" class="sc-reset-filter-btn mt-4">
        Reset Filters
      </button>
    </div>
  </div>

</div>
